/**
 * Leitura dos erros do DRF nas telas do Balanceamento de Linha.
 *
 * O envelope é sempre `{error: {message, status_code, errors}}` (ver
 * `apps/core/exceptions.custom_exception_handler`), e é de `errors` que sai a mensagem
 * que a pessoa lê. Compartilhado entre a página de Cadastros e os editores de bloco —
 * duplicar isso deixaria uma das telas dizendo "Erro ao salvar" onde a outra diz o
 * motivo.
 */

/** Erro de um campo específico: `{errors: {campo: [msg]}}` — vira mensagem inline. */
export function erroDeCampo(err: unknown, campo: string): string | null {
  const dados = (err as { response?: { data?: { error?: { errors?: Record<string, string[]> } } } })
    ?.response?.data?.error?.errors;
  return dados?.[campo]?.[0] ?? null;
}

/**
 * A primeira mensagem legível, venha ela de campo simples (`{campo: [msg]}`) ou
 * aninhada — a rota chega como lista de objetos por etapa, e sem descer nela o usuário
 * veria "Erro ao salvar" no lugar de "o teto é de 5 alternativos". Também é por aqui que
 * sai o `non_field_errors` do `unique_together`.
 */
export function primeiraMensagem(err: unknown): string | null {
  const raiz = (err as { response?: { data?: { error?: { errors?: unknown } } } })?.response?.data?.error?.errors;
  const buscar = (no: unknown): string | null => {
    if (typeof no === 'string') return no;
    if (Array.isArray(no)) {
      for (const item of no) {
        const achado = buscar(item);
        if (achado) return achado;
      }
      return null;
    }
    if (no && typeof no === 'object') {
      for (const valor of Object.values(no)) {
        const achado = buscar(valor);
        if (achado) return achado;
      }
    }
    return null;
  };
  return buscar(raiz);
}
